import { Component, HostListener, OnDestroy, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConnectionService } from './core/services/PWA/connection.service';
import { Subscription } from 'rxjs';
import { AuthService } from './core/services/auth/auth.service';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit, OnDestroy {
  private auth = inject(AuthService);
  private translate = inject(TranslateService);
  private connection = inject(ConnectionService);
  private swUpdate = inject(SwUpdate);

  private connectionSubscription: Subscription;

  constructor() {
    this.translate.addLangs(['en', 'es']);
    this.translate.setDefaultLang('en');

    const browserLang: string = this.translate.getBrowserLang();
    this.translate.use(browserLang.match(/en|es/) ? browserLang : 'en');
  }

  ngOnInit(): void {
    this.connectionSubscription = this.connection.onlineStatus$.subscribe();

    if (!this.swUpdate.isEnabled) return;
    // Solicitar recargar la página cuando se detecte una nueva versión del front
    this.swUpdate.versionUpdates.pipe(
      filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
    ).subscribe(() => {
      Swal.fire({
        title: 'Nueva versión disponible',
        text: 'Hay una nueva versión de Agente de Prensa. ¿Deseas recargar la página ahora?',
        icon: 'info',
        confirmButtonText: 'Recargar',
        cancelButtonText: 'Más tarde',
        showCancelButton: true,
        allowOutsideClick: false,
      }).then(result => {
        if (result.isConfirmed) document.location.reload();
      });
    });
    // Buscar actualizaciones cada 4 horas
    setInterval(() => this.swUpdate.checkForUpdate(), 4 * 3600 * 1000);
  }

  ngOnDestroy(): void {
    this.connectionSubscription.unsubscribe();
  }

  @HostListener('window:storage', ['$event'])
  handleStorage(event: StorageEvent) {
    if (event.storageArea.length === 0) {
      this.auth.updateToken(null);
    }
  }
}
